import type { HydratedUser, TokenPayload } from "@packsize/identity-api-sdk";
import { createContext } from "react";

import type { ApplicationName } from "../../types";

export type getLoginDestinationFunc = (
	user: HydratedUser | null,
	decodedToken: TokenPayload | null,
	returnTo: string | null,
) => string;

export interface SiteLoginResult {
	user: HydratedUser;
	decodedToken: TokenPayload | null;
}

interface AuthenticationContextProps {
	authenticated: boolean | undefined;
	applicationName: ApplicationName;
	applicationEnvironment?: string;
	logout: () => void;
	loginToSite: (tenantId: string) => Promise<SiteLoginResult | null>;
	getLoginDestination: getLoginDestinationFunc;
	ssoOnly?: true;
}

const initialState: AuthenticationContextProps = {
	authenticated: undefined,
	applicationName: "",
	applicationEnvironment: undefined,
	logout: () => undefined,
	getLoginDestination: () => "/",
	loginToSite: async () => null,
};

export const AuthenticationContext = createContext<AuthenticationContextProps>(initialState);
